/* Symbys listicle — sticky bars, reveal animations, scroll depth + CTA tracking.
   Reads the lander id off .lp-root[data-lander]. Degrades to a fully readable
   static page if IntersectionObserver is missing or JS is off entirely. */
(function () {
  var root = document.querySelector('.lp-root');
  if (!root) return;

  var lander = root.getAttribute('data-lander') || 'unknown';
  window.__lander = lander;

  /* ---------------- event bus ----------------
     Four destinations, each independently optional:
       1. Meta pixel      — fbq is exposed to the page by the Facebook sales channel
       2. Shopify Customer Events — the ONLY route to Shopify's native GA4, which runs
                            in a sandbox that cannot see gtag on the page. A Custom Pixel
                            subscribes to these and forwards wherever you want. This also
                            inherits Shopify's consent handling.
       3. gtag            — only exists if GA4 is hand-installed in the theme. Usually absent.
       4. dataLayer       — only consumed if GTM is installed in the theme. Usually absent.
  */
  function track(fbName, gaName, params) {
    var payload = {};
    for (var k in params) { if (params.hasOwnProperty(k)) payload[k] = params[k]; }
    payload.lander = lander;
    try { if (window.fbq) window.fbq('trackCustom', fbName, payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(gaName, payload);
      }
    } catch (e) {}
    try { if (window.gtag) window.gtag('event', gaName, payload); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: gaName, lander: lander, params: payload });
    } catch (e) {}
  }

  track('LanderView', 'lander_view', {});

  /* ---------------- CTA clicks by position ---------------- */
  root.addEventListener('click', function (ev) {
    var a = ev.target.closest ? ev.target.closest('[data-cta]') : null;
    if (!a) return;
    track('LanderCTAClick', 'lander_cta_click', { position: a.getAttribute('data-cta') });
  }, true);

  var hero = document.getElementById('hero');
  var sticky = document.getElementById('sticky');
  var mcta = document.getElementById('mcta');
  var offer = document.getElementById('offer');

  if (!('IntersectionObserver' in window)) {
    var all = root.querySelectorAll('.io');
    for (var i = 0; i < all.length; i++) all[i].classList.add('seen');
    return;
  }

  /* ---------------- sticky bars ---------------- */
  if (hero && sticky && mcta) {
    new IntersectionObserver(function (e) {
      var past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      sticky.classList.toggle('on', past);
      mcta.classList.toggle('on', past);
    }, { threshold: 0 }).observe(hero);
  }

  /* ---------------- reveal on scroll ---------------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (x) {
      if (x.isIntersecting) { x.target.classList.add('seen'); io.unobserve(x.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  root.querySelectorAll('.io').forEach(function (el) { io.observe(el); });

  /* ---------------- hide mobile CTA while the offer is on screen ---------------- */
  if (offer && mcta && hero) {
    new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { mcta.classList.remove('on'); }
      else if (hero.getBoundingClientRect().bottom < 0) { mcta.classList.add('on'); }
    }, { threshold: 0.35 }).observe(offer);
  }

  /* ---------------- scroll depth 25 / 50 / 75 / 100 ---------------- */
  var depths = [25, 50, 75, 100];
  var markers = depths.map(function (d) {
    var m = document.createElement('div');
    m.className = 'lp-depth';
    m.setAttribute('data-depth', d);
    m.style.top = d === 100 ? 'calc(100% - 2px)' : d + '%';
    root.appendChild(m);
    return m;
  });

  var fired = {};
  var dio = new IntersectionObserver(function (es) {
    es.forEach(function (x) {
      if (!x.isIntersecting) return;
      var d = x.target.getAttribute('data-depth');
      if (fired[d]) return;
      fired[d] = true;
      dio.unobserve(x.target);
      track('LanderScroll', 'lander_scroll', { depth: parseInt(d, 10) });
    });
  }, { threshold: 0 });
  markers.forEach(function (m) { dio.observe(m); });
})();
